import useBillingState from 'hooks/billing/useBillingState';
import useCurrentSubscriptionHelper from 'hooks/billing/useCurrentSubscriptionHelper';
import useEcoms from 'hooks/useEcoms';
import { useMemo } from 'react';
import { Feature } from '../../../pb/subscription/v1/addon_pb';

const useAddonEnabled = (feature: Feature): { isAddonEnabled: boolean | null; isLoading: boolean } => {
    const { activeSubscriptions, plans, isLoading: billingLoading } = useBillingState();
    const { addons, isLegacy, isLoading } = useCurrentSubscriptionHelper();
    const { selectedEcom, fetching } = useEcoms();

    // Checks whether a given addon feature is enabled for the current subscription.
    const isAddonEnabled = useMemo(() => {
        // New path: proto subscription addons list
        if (!isLegacy) return addons.some((a) => a.name === feature);
        // Legacy path: REST billing state — find the active plan and check its addons by string key
        const activeSub = activeSubscriptions?.find((el) => el.ecom_id === selectedEcom?.id);
        if (!activeSub) return null;
        const plan = plans?.find((p) => p.id == activeSub.plan_id);
        return !plan ? false : !!plan.addons.find((a) => a.name === Feature[feature]);
    }, [isLegacy, addons, feature, activeSubscriptions, selectedEcom, plans]);

    const loading = useMemo(() => isLoading || fetching || billingLoading, [isLoading, fetching, billingLoading]);

    return { isAddonEnabled, isLoading: loading };
};

export default useAddonEnabled;
